// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
var ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var NotificationSettings = require("./NotificationSettings.bs.js");
var MarkupHelpers = require("components/MarkupHelpers");
var EmailPreferencesPageRelayQuery_graphql = require("../../__generated__/EmailPreferencesPageRelayQuery_graphql.bs.js");

var convertVariables = EmailPreferencesPageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = EmailPreferencesPageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = EmailPreferencesPageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, EmailPreferencesPageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, EmailPreferencesPageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(EmailPreferencesPageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(EmailPreferencesPageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(EmailPreferencesPageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(EmailPreferencesPageRelayQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function EmailPreferencesPageRelay(props) {
  var data = use(undefined, undefined, undefined, undefined);
  var chapter = data.currentChapterV5;
  var tmp;
  if (chapter !== undefined) {
    var userNotificationSettings = data.userNotificationSettingsV5;
    tmp = userNotificationSettings !== undefined ? JsxRuntime.jsx(NotificationSettings.make, {
            userNotificationSettings: userNotificationSettings.fragmentRefs,
            chapter: chapter.fragmentRefs
          }) : JsxRuntime.jsx(ErrorComponent.make, {
            message: "We encountered an error loading your preferences. Please refresh and try again later..."
          });
  } else {
    tmp = JsxRuntime.jsx(ErrorComponent.make, {
          message: "We encountered an error loading your preferences. Please refresh and try again later..."
        });
  }
  return JsxRuntime.jsxs(MarkupHelpers.ContentBox, {
              paddingFull: true,
              hasShadow: true,
              children: [
                JsxRuntime.jsx(PageUITitle.make, {
                      title: "Email Notifications"
                    }),
                tmp
              ]
            });
}

var make = EmailPreferencesPageRelay;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
